import { render, staticRenderFns } from "./WalletBtn.vue?vue&type=template&id=8aac305e&scoped=true"
import script from "./WalletBtn.vue?vue&type=script&lang=js"
export * from "./WalletBtn.vue?vue&type=script&lang=js"
import style0 from "./WalletBtn.vue?vue&type=style&index=0&id=8aac305e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aac305e",
  null
  
)

export default component.exports